
<div class="mb-2">
  <div class="label mt-3 mb-1">{{ label }}</div>

  <div class="btn-group d-flex align-items-center" role="group">
    <button
      type="button"
      class="btn btn-xs"
      v-bind:class="{
        'btn-outline-secondary': value,
        'btn-secondary': !value,
      }"
      v-on:click="updateState(false)"
    >
      {{ negativeText }}
    </button>
    <button
      type="button"
      class="btn btn-xs"
      v-bind:class="{
        'btn-outline-primary': !value,
        'btn-primary': value,
      }"
      v-on:click="updateState(true)"
    >
      {{ positiveText }}
    </button>
  </div>
</div>
